import request from '@/utils/request'; // 获取列表

export function fetchManageList(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/goodsLostAndFound/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/update',
    method: 'post',
    data: data
  });
}
export function fetchClassList(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/update',
    method: 'post',
    data: data
  });
}
export function fetchDetailForManage(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/update',
    method: 'post',
    data: data
  });
}
export function fetchReadList(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/readerList',
    method: 'post',
    data: data
  });
}
export function fetchRelease(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/publishGoodsLostAndFound',
    method: 'post',
    data: data
  });
}
export function fetchLostCreate(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/receiveLostGoods',
    method: 'post',
    data: data
  });
}
export function fetchLostList(data) {
  return request({
    url: '/pmsservice/api/goodsGoods/findGoodsUnclaimedList',
    method: 'post',
    data: data
  });
}
export function fetchSituationList(data) {
  return request({
    url: '/pmsservice/api/goodsGoods/list',
    method: 'post',
    data: data
  });
}
export function fetchHistoryList(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/findAuditRecordList',
    method: 'post',
    data: data
  });
}
export function fetchAuditList(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/getAuditRecordInfo',
    method: 'post',
    data: data
  });
}
export function fetchUpdateAudit(data) {
  return request({
    url: '/pmsservice/api/goodsLostAndFound/updateAuditState',
    method: 'post',
    data: data
  });
}